import React from "react"

type SliderProps = {
  value?: number
  minimumValue?: number
  maximumValue?: number
  step?: number
  disabled?: boolean
  onValueChange?: (value: number) => void
  onSlidingComplete?: (value: number) => void
  style?: React.CSSProperties
}

export default function Slider({
  value = 0,
  minimumValue = 0,
  maximumValue = 1,
  step = 0.01,
  disabled,
  onValueChange,
  onSlidingComplete,
  style,
}: SliderProps) {
  return (
    <input
      type="range"
      min={minimumValue}
      max={maximumValue}
      step={step}
      value={value}
      disabled={disabled}
      style={{ width: "100%", ...style }}
      onChange={(e) => onValueChange?.(Number(e.target.value))}
      onMouseUp={(e) => onSlidingComplete?.(Number((e.target as HTMLInputElement).value))}
      onTouchEnd={(e) => onSlidingComplete?.(Number((e.target as HTMLInputElement).value))}
    />
  )
}
